/* eslint-disable import/prefer-default-export */
import { ITenant } from '../store/V2/TenantsSlice';
import { IUser } from '../store/UserSlice';
import { IGroup } from '../store/V2/GroupsSlice';

export const isFromTutopiyaTenant = (tenant?: ITenant) => {
  if (!tenant) {
    return false;
  }

  return tenant.key !== 'TUTOPIYA';
};

export const getAppBaseUrlForTenant = (tenant?: ITenant) => {
  if (!tenant) return undefined;

  const previousDomainName = (process.env.REACT_APP_BASE_URL || '')
    .replace('https://', '')
    .replace('/learning-portal', '')
    .trim();

  const newDomainName = (process.env.REACT_APP_BASE_URL || '')
    .replace(previousDomainName, tenant.domain)
    .trim();

  return newDomainName;
};

/**
 * Gets the app logo path from user's groups or tenant fallback
 * @param authUser - The authenticated user object
 * @param tenant - The tenant object
 * @returns The app logo path string or undefined
 */
export const getAppLogoPath = (
  authUser?: IUser,
  tenant?: ITenant
): string | undefined => {
  const groups = authUser?.groups as IGroup[] | undefined;
  const groupLogoPath = groups?.[0]?.appLogoPath;

  return groupLogoPath || tenant?.appLogoPath;
};
